import { favoriteConstants } from '../_constants';

// Favorite Funds
export const updateFavoriteQueries = (queries) => ({
  type: favoriteConstants.UPDATE_FAVORITE_FUNDS_QUERIES,
  payload: queries
});

export const updateFavoriteTableColumns = (columns) => ({
  type: favoriteConstants.UPDATE_FAVORITE_FUNDS_TABLE_COLUMNS,
  payload: columns
});

export const updateLocalFavoriteFunds = (data) => ({
  type: favoriteConstants.UPDATE_LOCAL_FAVORITE_FUNDS,
  payload: data
});

export const addFavoriteFund = (data) => ({
  type: favoriteConstants.ADD_FAVORITE_FUND,
  payload: data
});

export const deleteFavoriteFund = (data) => ({
  type: favoriteConstants.DELETE_FAVORITE_FUND,
  payload: data
});

export const putFavoriteFunds = (data) => ({
  type: favoriteConstants.PUT_FAVORITE_FUNDS,
  payload: data
});

export const fetchFavoriteFundsByAccountStart = () => ({
  type: favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_START
});

export const fetchFavoriteFundsByAccountSuccess = (funds) => ({
  type: favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS,
  payload: funds
});

export const fetchFavoriteFundsByAccountFailure = (errorMessage) => ({
  type: favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE,
  payload: errorMessage
});

export const fetchNavFavoriteFundsByAccountStart = (data) => ({
  type: favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_START,
  payload: data
});

export const fetchNavFavoriteFundsByAccountSuccess = (data) => ({
  type: favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS,
  payload: data
});

export const fetchNavFavoriteFundsByAccountFailure = (errorMessage) => ({
  type: favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE,
  payload: errorMessage
});

// Favorite Copyport
export const fetchFavoriteCopyportStart = () => ({
  type: favoriteConstants.FETCH_FAVORITE_COPYPORT_START
});

export const fetchFavoriteCopyportSuccess = (copyportList) => ({
  type: favoriteConstants.FETCH_FAVORITE_COPYPORT_SUCCESS,
  payload: copyportList
});

export const fetchFavoriteCopyportFailure = (errorMessage) => ({
  type: favoriteConstants.FETCH_FAVORITE_COPYPORT_FAILURE,
  payload: errorMessage
});
